import { Pipe, PipeTransform } from "@angular/core";
import { LanguageService } from "@core/services";

@Pipe({
  name: "price",
})
export class PricePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(
    value: number | string | null | undefined
  ): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
      return '-';
    }

    const locale = this.languageService.getLocale() || 'es-ES';

    // TODO estudiar como coger es o en
    return numericValue.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
